import { PropsWithChildren } from 'react';

import type { BaseComponentProps } from '../../../../types/common';

import styles from './styles.module.css';

export interface CardMediaProps extends BaseComponentProps {
  /**
   * The children of the CardMedia component.
   */
  children: PropsWithChildren['children'];

  /**
   * The className of the CardMedia component.
   */
  className?: string;
}

/**
 * Media section of the Card component.
 * Use with Card.Adornment to add positioned content overlays.
 */
export const CardMedia: React.FC<CardMediaProps> = ({
  children,
  dataTestId,
}) => {
  return (
    <div
      className={styles['card-media']}
      data-slot="media"
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};
